module.exports = __webpack_public_path__ + "static/media/advertisement-confirmation.588e6d87.svg";